import React from 'react';
import { BodySmallText, H4Text } from '@prisjakt/ui/text/variants';
import { useAppContext } from 'src/components/app-context';
import { StyleUnderlinedInfoPageLink } from './styles';

export const OurChoiceInfoText = () => {
  const { t, market } = useAppContext();

  return (
    <>
      <H4Text>{t('product', 'prices.our-choice')}</H4Text>
      <p>
        <BodySmallText>
          {t('product', 'prices.our-choice-explanation')}
        </BodySmallText>{' '}
        <StyleUnderlinedInfoPageLink id={market.infoPageMap?.priceInformation}>
          {t('common', 'button.read-more')}
        </StyleUnderlinedInfoPageLink>
      </p>
    </>
  );
};
